export const enum LocalStorageCachedKeys {
  ListParams = 'listParams', // caching list state, e.g. pagination, filters
}
